import { defaultAiAssistantInfo } from "@memorang/helpers/constants";

export const defaultFont = "opensans" as const;

export const defaultAlertConfigs = {
	quiz: {
		severity: "info" as const,
		icon: "format-list-checks",
		description:
			"Start with a short, free diagnostic to familiarize yourself with the test format.",
	},
	practiceTest: {
		severity: "info" as const,
		icon: "clipboard-text-outline",
		description:
			"Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
	},
	quizAndPracticeTest: {
		severity: "info" as const,
		icon: "format-list-checks",
		description:
			"Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
	},
	topicMastery: {
		severity: "info" as const,
		icon: "chart-line",
		title: "Mastery Breakdown",
		description:
			"The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
	},
};

export const defaultPracticeTestConfig = {
	header: {
		title: "Practice Tests",
		subtitle:
			"Take practice tests to assess your exam readiness, strengths, and opportunities for improvement",
	},
	label: "Practice Tests",
	summativeTestAlertConfig: defaultAlertConfigs,
	enabled: {
		mobile: false,
		web: true,
	},
	deviceRecommendationDialog: {
		enabled: false,
		title: "Best experience on laptop",
		message:
			"For the best experience, we recommend taking practice tests on a laptop or desktop computer.",
	},
};

export const defaultSessionViewConfig = {
	showFlightCalculator: false,
	showCrossOut: true,
};

export const defaultCitationsConfig = {
	visible: false,
	showTextBasedCitationOnly: false,
};

export const defaultDeploymentsConfig = {
	autoDeploymentEnabled: true,
};

export const defaultMaintenanceConfig = {
	title: "We'll be right back",
	subtitle:
		"We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience.",
};

export const defaultExamConfig = {
	practiceTest: defaultPracticeTestConfig,
	examDateDisclaimer:
		"This date is only to guide your study schedule within the app. It does not affect your official exam registration.",
};

export const defaultLeaderboardsConfig = {
	timePeriods: ["all_time", "month", "week"] as const,
	scopes: ["global", "friends"] as const,
	showUsersPodium: true,
	numUsersToDisplay: 10,
};

/**
 * Default values for app config fields that have defaults in the Zod schema.
 * Used to merge with raw data when Zod validation is bypassed.
 */
export const defaultAppConfigValues = {
	app: {
		font: defaultFont,
		tagType: { "en-US": "Topic" },
		aiAssistant: defaultAiAssistantInfo,
		isImageChallengeApp: false,
		isStudyPackEnabled: true,
		showCountrySelection: false,
		deployments: defaultDeploymentsConfig,
		maintenance: defaultMaintenanceConfig,
		citations: defaultCitationsConfig,
		auth: { provider: "clerk" as const },
	},
	exam: defaultExamConfig,
	sessionView: defaultSessionViewConfig,
	leaderboards: defaultLeaderboardsConfig,
};
